import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import * as moment from "moment";

@IonicPage()
@Component({
  selector: 'page-order-details',
  templateUrl: 'order-details.html',
})
export class OrderDetailsPage {

  order: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.order = navParams.get("order");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderDetailsPage');
  }

  public formatDate(date) {
    let myMoment: moment.Moment;
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  openPrescriptionImage(rx_id: string) {
    window.open(this.order.prescription_files[rx_id], "_blank")
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-details/order-details.ts